import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { RouterConfig } from './RouterConfig';

export const App = () => (
  <ChakraProvider>
    <RouterConfig />
  </ChakraProvider>
);
